
(()=>{
 if(window.catalogCardsReady)return;window.catalogCardsReady=true;
 const palette={'黑色':'#202729','經典黑':'#171717','black':'#171e20','白色':'#eeeae0','經典白':'#f4f2ea','白':'#eeeae0','米白色':'#e4ddc9','沙色':'#c4baa0','Khaki':'#baac8b','卡其色':'#b19a77','象牙白':'#e9e2d2','土星棕':'#746052','午夜藍':'#253348','碧湖藍':'#6f9ca0','勃根地紅':'#683742','火星棕':'#80534a','宇宙橙':'#b76243','雪地色系':'#aab9b6','冰河藍':'#8aafb9','極致黑':'#1c2224','永夜藍':'#253d50','焙茶棕':'#8a6d52','白晝沙':'#c5b79b','白晝沙影':'#d8ccb6','日蝕藍影':'#344354','沙丘暮影':'#928372','闇夜黑':'#171e20','日蝕藍':'#344354','可可棕':'#795b45','孔雀藍':'#247b85','皇室藍':'#274a96','太空灰':'#969b9d'};
 const strings=()=>document.getElementById('CatalogStrings')?JSON.parse(document.getElementById('CatalogStrings').textContent):{};
 const attachAttribution=(card)=>{
  if(!card.dataset.sourceUrl)return;
  const source=new URL(card.dataset.sourceUrl,location.origin);
  const keys=['pr_prod_strat','pr_rec_id','pr_rec_pid','pr_ref_pid','pr_seq','_pos','_sid','_ss'];
  card.querySelectorAll('[data-native-link],[data-r52-link],[data-url]').forEach(node=>{
   const raw=node.dataset.url||node.getAttribute('href');if(!raw)return;
   const url=new URL(raw,location.origin);
   keys.forEach(key=>{if(source.searchParams.has(key))url.searchParams.set(key,source.searchParams.get(key));});
   if(node.dataset.url)node.dataset.url=url.pathname+url.search;else node.setAttribute('href',url.pathname+url.search);
  });
 };
 const setSecondary=(card,src,cover)=>{
  const image=card.querySelector('[data-card-secondary]');if(!image)return;
  image.hidden=!src||src===cover;
  if(image.hidden)image.removeAttribute('src');else image.src=src;
 };
 function initCards(scope){
 const cards=[...scope.querySelectorAll('article[data-product-id]')];
 if(scope.matches('article[data-product-id]'))cards.unshift(scope);
 cards.forEach(card=>{
  attachAttribution(card);
  const template=card.querySelector('template[data-catalog-modal]');
  if(template&&!document.getElementById('QuickShopModal-'+card.dataset.productId))document.body.append(template.content.cloneNode(true));
  if(scope.hasAttribute('data-follow-presentation')){
   const context=new URL(location.href).searchParams.get('presentation')||scope.dataset.recommendationContext;
   if(['men','women'].includes(context))card.hidden=card.dataset.context!==context;
  }
 });
 scope.querySelectorAll('[data-catalog-native]').forEach(card=>{
  if(card.dataset.swatchesReady)return;card.dataset.swatchesReady='true';
  const buttons=[...card.querySelectorAll('[data-native-colour]')];
  const apply=button=>{
   const cover=button.dataset.cover;if(!cover)return;
   card.querySelector('[data-native-link]').href=button.dataset.url;
   const img=card.querySelector('[data-native-cover]');img.src=cover;img.removeAttribute('srcset');setSecondary(card,button.dataset.secondary,cover);
   const price=card.querySelector('[data-native-price]');const content=button.querySelector('template');if(content)price.replaceChildren(content.content.cloneNode(true));
   buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  };
  buttons.forEach(button=>{
   if(!button.style.getPropertyValue('--swatch'))button.style.setProperty('--swatch',palette[button.dataset.nativeColour]||'#aeb4b3');
   
  });
  window.TZCardSwatches.bind({container:card,selector:'[data-native-colour]',key:b=>b.dataset.nativeColour,preview:button=>{const changed=button.getAttribute('aria-pressed')!=='true';apply(button);window.dataLayer=window.dataLayer||[];if(changed)window.dataLayer.push({event:'tz_presentation_colour_select',canonical_product_id:card.dataset.productId,variant_id:button.dataset.variant,presentation_context:card.dataset.context,colour:button.dataset.nativeColour,source_section:scope.dataset.catalogDiscovery||'catalog-browse'});return button.dataset.url;}});
 });
 scope.querySelectorAll('[data-r52-card]').forEach(card=>{
  if(card.dataset.swatchesReady)return;card.dataset.swatchesReady='true';
  const data=JSON.parse(card.querySelector('[data-r52-data]').textContent);
  const buttons=[...card.querySelectorAll('[data-r52-colour]')];
  buttons.forEach(button=>button.style.setProperty('--swatch',button.dataset.catalogSwatch||palette[button.dataset.r52Colour]||'#aeb4b3'));
  window.TZCardSwatches.bind({container:card,selector:'[data-r52-colour]',key:b=>b.dataset.r52Colour,preview:button=>{
    const colour=button.dataset.r52Colour,changed=button.getAttribute('aria-pressed')!=='true';
    const candidates=data.colourIndex===null?data.variants:data.variants.filter(v=>window.catalogColourKey(v.options[data.colourIndex],data.productId)===colour);
    const variant=candidates.find(v=>v.available)||candidates[0];const gallery=data.galleries[colour];if(!variant||!gallery?.cover)return;
    const link=card.querySelector('[data-r52-link]');const url=new URL(link.href,location.origin);url.searchParams.set('variant',variant.id);url.searchParams.set('presentation',data.context);link.href=url.pathname+url.search;
    const img=card.querySelector('[data-r52-cover]');img.src=gallery.cover;img.removeAttribute('srcset');img.alt=data.title;setSecondary(card,gallery.secondary,gallery.cover);
    const price=card.querySelector('[data-r52-price]');const priceTemplate=card.querySelector('template[data-r52-variant="'+variant.id+'"]');if(priceTemplate)price.replaceChildren(priceTemplate.content.cloneNode(true));
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    window.dataLayer=window.dataLayer||[];if(changed)window.dataLayer.push({event:'tz_presentation_colour_select',canonical_product_id:data.productId,canonical_product_handle:data.handle,variant_id:String(variant.id),presentation_context:data.context,colour,source_section:scope.dataset.catalogDiscovery||'catalog-browse'});
    return link.href;
  }});
 });
 }
 function initRoot(root){
 if(root.dataset.browseReady)return;root.dataset.browseReady='true';
 initCards(root);
 const grid=root.querySelector('.catalog-browse__grid');
 const pager=root.querySelector('[data-catalog-pager]');
 const button=pager?.querySelector('[data-catalog-more]');
 const count=pager?.querySelector('[data-catalog-count]');
 if(!grid||!pager||!button||!count)return;
 const key=card=>card.dataset.productId+':'+card.dataset.context;
 const seen=new Set([...grid.querySelectorAll('article[data-product-id]')].map(key));
 const visited=new Set();
 let next=pager.dataset.nextUrl,loading=false;
 const messages=strings();
 if(pager.dataset.countShown)messages.shown=pager.dataset.countShown;
 if(pager.dataset.countAll)messages.all_shown=pager.dataset.countAll;
 const update=()=>{count.textContent=(messages.shown||'已顯示 __count__ 款').replace('__count__',seen.size);button.hidden=!next;button.disabled=false;button.textContent=messages.load_more||'載入更多';};
 pager.querySelector('[data-catalog-fallback]').hidden=true;
 update();
 button.addEventListener('click',async()=>{
  if(loading||!next)return;
  loading=true;button.disabled=true;button.textContent=messages.loading||'載入中…';root.setAttribute('aria-busy','true');
  let added=0,firstNew;
  try{
   while(next&&!added){
    const url=new URL(next,location.href);
    if(root.dataset.catalogDiscovery==='search'){
     url.searchParams.delete('options');
     const prefix=new URL(location.href).searchParams.get('options[prefix]');
     if(prefix)url.searchParams.set('options[prefix]',prefix);
    }
    if(url.origin!==location.origin||url.pathname!==location.pathname||visited.has(url.href))throw new Error('Invalid pagination destination');
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),20000);
    let response;
    try{response=await fetch(url.href,{credentials:'same-origin',signal:controller.signal});}finally{clearTimeout(timer);}
    if(!response.ok)throw new Error('Page unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const scopeSelector=root.dataset.catalogDiscovery?'[data-catalog-discovery="'+root.dataset.catalogDiscovery+'"]':'.catalog-browse';
    const nextRoot=doc.querySelector(scopeSelector);
    const source=nextRoot?.querySelector('.catalog-browse__grid');
    const page=nextRoot?.querySelector('[data-catalog-pager]');
    if(!source||!page||doc.body.textContent.includes('Liquid error'))throw new Error('Invalid collection page');
    const cards=[...source.querySelectorAll('article[data-product-id][data-context]')];
    for(const card of cards){
     const identity=key(card);if(seen.has(identity))continue;
     seen.add(identity);grid.append(card);added++;if(!firstNew)firstNew=card;
    }
    visited.add(url.href);next=page.dataset.nextUrl;pager.dataset.nextUrl=next;
   }
   initCards(root);update();
   count.textContent=(next?(messages.shown||'已顯示 __count__ 款'):(messages.all_shown||'已顯示全部 __count__ 款')).replace('__count__',seen.size);
   if(!next&&firstNew)firstNew.querySelector('a')?.focus({preventScroll:true});
  }catch(error){
   button.hidden=false;button.disabled=false;button.textContent=messages.retry||'重試';count.textContent=messages.error||'暫時無法載入，請再試一次。';
  }finally{loading=false;root.removeAttribute('aria-busy');}
 });

 }
 const scan=()=>document.querySelectorAll('.catalog-browse,[data-catalog-discovery],[data-quick-context-card]').forEach(initRoot);
 scan();
 new MutationObserver(records=>{if(records.some(r=>r.addedNodes.length))scan();}).observe(document.body,{subtree:true,childList:true});
})();




